import AppDevelopment from "../images/app-development.svg";
import EcomDevelopment from "../images/ecommerce-development.svg";
import Uiux from "../images/ui-ux.svg";
import QA from "../images/QA.svg";
import DataAnalytics from "../images/data-migration.svg";
import Shopify from "../images/shopify-development.svg";
import Seo from "../images/seo.svg";

const serviceCardData = [
  {
    id: 1,
    bgColor: "#ffcaad",
    clsName: "pastel-senary",
    image: Shopify,
    title: "Shopify Enterprise Services",
    description:
      "Build your eCommerce platform with our esteemed Shopify Enterprise Services and attract more customers daily.",
    pathUrl: "/services/shopify-enterprise-services",
    imageWidth: 193,
    imageHeight: 185,
  },
  {
    id: 2,
    bgColor: "#D5C3FA",
    clsName: "pastel-teritory",
    image: Uiux,
    title: "UI / UX Development",
    description:
      "Consult the best UI UX Development Company to brainstorm the best-in-class interface for your mobile and web apps and websites.",
    pathUrl: "/services/ui-ux-development",
    imageWidth: 227,
    imageHeight: 182,
  },
  {
    id: 3,
    bgColor: "#8BD5CB",
    clsName: "pastel-primary",
    image: AppDevelopment,
    title: "Mobile App Development",
    description:
      "How to make your app stand out in the plethora of applications in the market today? One solution - hire eQuest as your mobile app development company!",
    pathUrl: "/services/custom-application-development",
    imageWidth: 162,
    imageHeight: 172,
  },
  {
    id: 4,
    bgColor: "#FECACA",
    clsName: "pastel-secondary",
    image: EcomDevelopment,
    title: "eCommerce Development",
    description:
      "Hire us to make the tedious task of listing your product ranges online a swift one!",
    pathUrl: "/services/ecommerce-development",
    imageWidth: 162,
    imageHeight: 190,
  },
  {
    id: 5,
    bgColor: "#A2D59C",
    clsName: "pastel-quinary",
    image: DataAnalytics,
    title: "Data Scrapping & Analytics",
    description:
      "Use our data scrapping and analytics digital solutions to analyze and mine your data within seconds.",
    pathUrl: "/services/dataanalysis",
    imageWidth: 177,
    imageHeight: 181,
  },
  {
    id: 6,
    bgColor: "#F69FD4",
    clsName: "pastel-quaternary",
    image: QA,
    title: "Quality Assurance",
    description:
      "Our quality experts follow exhaustive checklists and ensure to tick every box before approving your project.",
    pathUrl: "/services/qa-services",
    imageWidth: 224,
    imageHeight: 169,
  },
  {
    id: 7,
    bgColor: "#D5C3FA",
    clsName: "pastel-septenary",
    image: Seo,
    title: "Search Engine Optimization",
    description:
      "Visibility is everything! Bring your website on the top Google pages with our expert SEO services.",
    pathUrl: "/services/seo",
    imageWidth: 166,
    imageHeight: 164,
  },
];

export default serviceCardData;
